@if (scrapSpec$ | async; as scrapSpec) {
  <mat-tab-group class="full" animationDuration="0">
    <!-- Bom Matcher and Bom Path configs -->
    <mat-tab label="{{ 'context.config' | translate }}">
      <elder-pane class="p-pane">
        <elder-pane-subtitle>{{ 'context.name' | translate }}</elder-pane-subtitle>
        <mat-form-field>
          <mat-label>{{ 'context.name' | translate }}</mat-label>
          <input
            matInput
            name="scrap-spec-name-input"
            placeholder="{{ 'context.name' | translate }}"
            [(ngModel)]="scrapSpec.name"
            required
            elderPlugParentForm
          />
        </mat-form-field>
        <div class="flex layout-row gap-lg">
          <div class="flex layout-col gap-md">
            <elder-pane-subtitle>{{ 'bom.cBom' | translate }}</elder-pane-subtitle>
            <!-- Type -->
            <mat-form-field>
              <mat-label>{{ 'context.selection' | translate }}</mat-label>
              <elder-select
                appScrapConsumptionSelector
                name="type"
                required
                elderPlugParentForm
                valueAsId
                [(value)]="scrapSpec.consumptionSelector"
              >
              </elder-select>
            </mat-form-field>
            <!-- Consumption Path -->
            @if (scrapSpec?.consumptionSelector === ScrapConsumptionSelector.PATH) {
              <mat-form-field>
                <mat-label
                  >{{ 'bom.component-path' | translate }} ({{ 'bom.cBom' | translate }})</mat-label
                >
                <input
                  matInput
                  name="scrap-consumption-component-path-input"
                  placeholder="{{ 'bom.component-path' | translate }} ({{
                    'bom.cBom' | translate
                  }})"
                  [(ngModel)]="scrapSpec.consumptionComponentPath"
                  required
                  elderPlugParentForm
                />
              </mat-form-field>
            }
            <!-- Consumption Bom Matcher -->
            @if (scrapSpec?.consumptionSelector === ScrapConsumptionSelector.MATCHER) {
              <app-bom-matcher-detail
                class="flex"
                [matcher]="scrapSpec.consumptionComponentMatcher"
              >
              </app-bom-matcher-detail>
            }
          </div>
          <div class="flex layout-col gap-md">
            <elder-pane-subtitle>{{ 'bom.fBom' | translate }}</elder-pane-subtitle>
            <!-- Type -->
            <mat-form-field>
              <mat-label>{{ 'context.selection' | translate }}</mat-label>
              <elder-select
                appScrapFinishedSelector
                name="type"
                required
                elderPlugParentForm
                valueAsId
                [(value)]="scrapSpec.finishedSelector"
              >
              </elder-select>
            </mat-form-field>
            <!-- Finished Path -->
            @if (scrapSpec?.finishedSelector === ScrapFinishedSelector.PATH) {
              <mat-form-field>
                <mat-label
                  >{{ 'bom.component-path' | translate }} ({{ 'bom.mBom' | translate }})</mat-label
                >
                <input
                  matInput
                  name="scrap-finished-component-path-input"
                  placeholder="{{ 'bom.component-path' | translate }} ({{
                    'bom.mBom' | translate
                  }})"
                  [(ngModel)]="scrapSpec.finishedComponentPath"
                  required
                  elderPlugParentForm
                />
              </mat-form-field>
            }
            <!-- Finished Material Id -->
            @if (scrapSpec?.finishedSelector === ScrapFinishedSelector.MATERIAL_ID) {
              <mat-form-field>
                <mat-label>{{ 'materials.number' | translate }}</mat-label>
                <input
                  matInput
                  name="scrap-finished-component-material-id-input"
                  placeholder="{{ 'materials.number' | translate }}"
                  [(ngModel)]="scrapSpec.finishedComponentMaterialId"
                />
              </mat-form-field>
            }
            <!-- Finished Component name -->
            @if (scrapSpec?.finishedSelector === ScrapFinishedSelector.MATERIAL_ID) {
              <mat-form-field>
                <mat-label>{{ 'bom.component-name' | translate }}</mat-label>
                <input
                  matInput
                  name="scrap-finished-component-name-input"
                  required
                  elderPlugParentForm
                  placeholder="{{ 'bom.component-name' | translate }}"
                  pattern="{{ bomComponentNameValidator }}"
                  [(ngModel)]="scrapSpec.finishedComponentName"
                />
              </mat-form-field>
            }
          </div>
        </div>
      </elder-pane>
    </mat-tab>
    <mat-tab label="{{ 'context.rules' | translate }}">
      <elder-basic-pane-layout class="full p-0">
        <elder-pane class="flex-30 outlined">
          <elder-table
            class="flex"
            matSort
            denseHorizontal
            [data]="scrapSpec.rules"
            [elderTableActivation]="{ autoActivation: 'always', autoActivateItem: 'first' }"
            [activeItem]="selectedRule$ | async"
            (activeItemChange)="selectedRule$.next($event)"
            [selectionMultiEnabled]="true"
            [selectionVisible]="true"
          >
            <elder-data-toolbar
              *elderTableToolbar
              [canAdd]="true"
              [canRemove]="true"
              [canMore]="false"
              (requestNew)="addRule()"
              (requestRemove)="onRemoveRules($event)"
            >
            </elder-data-toolbar>
            <!-- icon -->
            <ng-container matColumnDef="icon">
              <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
              <td mat-cell *matCellDef>
                <mat-icon>label</mat-icon>
              </td>
            </ng-container>
            <!-- description Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef style="width: 60%" mat-sort-header>
                {{ 'context.description' | translate }}
              </th>
              <td mat-cell *matCellDef="let rule">{{ rule?.description }}</td>
            </ng-container>
            <!-- condition Column -->
            <ng-container matColumnDef="conditions">
              <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
                {{ 'skillSets.conditions.title' | translate }}
              </th>
              <td mat-cell *matCellDef="let rule">{{ rule?.conditions?.length }}</td>
            </ng-container>
          </elder-table>
        </elder-pane>
        <elder-pane class="outlined">
          <app-scrap-rule-detail class="flex" [scrapRule]="selectedRule$ | async">
          </app-scrap-rule-detail>
        </elder-pane>
      </elder-basic-pane-layout>
    </mat-tab>
  </mat-tab-group>
}
